import * as React from 'react';

export const useUniqueID = (prefix: string = 'xx') => {
  const [id] = React.useState(
    () => `${prefix}_${String(Math.random()).split('.')[1]}`,
  );
  return id;
};
